import React, {useEffect, useRef} from 'react';
import {getSetting} from "./utils/settings";
import {useChatContext} from "./ChatContext";
import {History} from "./History";
import {Overlay} from "./Overlay";
import {Window} from "./Window";
import {Shortcuts} from "./Shortcuts";

export function Chat(): React.ReactElement {
    const { chat, history } = useChatContext();

    // -------------------------------------------------------------------------------------------------------------
    // Reference: Chat
    // -------------------------------------------------------------------------------------------------------------
    const chatBotRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        chatBotRef.current?.classList.toggle('wvcb--is-open', chat.isOpen());
        chatBotRef.current?.classList.toggle('wvcb--is-maximized', chat.isMaximized());
    }, [chat.openState, chat.maximizedState]);

    // -------------------------------------------------------------------------------------------------------------
    // Welcome Message
    // -------------------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (!history.hasMessages()) {
            history.addMessage({
                sender: "bot",
                text: getSetting('chat.welcome_message'),
                type: "text"
            });
        }
    }, [chat.openState, history.state]);

    const links = document.querySelectorAll( 'a[href="#chat"]' );

    links.forEach( ( link ) => {
        link.addEventListener( 'click', ( event ) => {
            event.preventDefault();
            chat.open();
        } );
    } );

    return (
        <div id="wvcb" className="wvcb" ref={chatBotRef}>
            <Shortcuts/>
            <Window>
                <History/>
            </Window>
            <Overlay/>
        </div>
    );
};
